import { render, staticRenderFns } from "./ApplySafety.vue?vue&type=template&id=798d84ba&scoped=true"
import script from "./ApplySafety.vue?vue&type=script&lang=js"
export * from "./ApplySafety.vue?vue&type=script&lang=js"
import style0 from "./ApplySafety.vue?vue&type=style&index=0&id=798d84ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798d84ba",
  null
  
)

export default component.exports